import { Grid } from '@mui/material'
import React from 'react'
import { Header } from '../../components/Header'
import { PiePagina } from '../../components/PiePagina'
import { Inscritos } from '../inscripciones/Inscritos'

export const InscritosEs = () => {
    return (
        <div className="fade-in">
            <Header></Header>
            <Grid container xs={12} md={12} direction="column" justifyContent="flex-start" alignItems="center" style={{ backgroundColor: '#2E2E2E', minHeight: '70vh' }}>
                <Grid container xs={12} md={12} direction="row" justifyContent="center" alignItems="center">
                    <h1>INSCRITOS</h1>
                </Grid>
                <Inscritos />

            </Grid>

            <PiePagina></PiePagina>
        </div>
    )
}
